import React from 'react';

const BookCover = ({
  title,
  logo,
  author,
  version,
  description,
  backgroundImage,
}) => {
  return (
    <div style={styles.page}>
      <div
        style={{
          ...styles.cover,
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <img src={logo} alt="Book Logo" style={styles.logo} />
        <h1 style={styles.title}>{title}</h1>
        <h3 style={styles.author}>by {author}</h3>
        <p style={styles.version}>Version: {version}</p>
        <p style={styles.description}>{description}</p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    width: '794px',
    height: '1123px',
    margin: '20px auto',
    border: '1px solid #000',
    backgroundColor: '#fff',
    boxShadow: '0 0 10px rgba(0,0,0,0.3)',
    padding: '40px',
    boxSizing: 'border-box',
  },
  cover: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    fontFamily: 'Georgia, serif',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    width: '150px',
    height: '150px',
    objectFit: 'contain',
    marginBottom: '30px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)', // Optional: make it more visible on image
    borderRadius: '8px',
    padding: '10px',
  },
  title: {
    fontSize: '40px',
    margin: '20px 0',
    color: '#000',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: '10px 20px',
    borderRadius: '8px',
  },
  author: {
    fontSize: '22px',
    fontStyle: 'italic',
    color: '#000',
    margin: '10px 0',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: '6px 16px',
    borderRadius: '6px',
  },
  version: {
    fontSize: '18px',
    margin: '10px 0',
    color: '#555',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: '4px 12px',
    borderRadius: '6px',
  },
  description: {
    fontSize: '20px',
    marginTop: '40px',
    padding: '0 60px',
    color: '#000',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '6px',
    padding: '20px',
  },
};

export default BookCover;
